import type { FC } from 'react'
export type MessageProps = {
  message: string
  hasError?: boolean
  className?: string
}

export const Message: FC<MessageProps> = ({
  message,
  hasError = false,
  className = '',
}) => {
  return (
    <p
      className={
        `w-full text-center text-white my-2 px-4 py-2 rounded border font-bold \
            ${hasError ? 'bg-red-400' : 'bg-green-400'} ${className}`
      }>
      {message}
    </p>
  )
}

export type ItemProps = {
  title: string
  text?: string
  className?: string
}

export const Item: FC<ItemProps> = ({ title, text, className = '' }) => {
  if (!text) return null
  return (
    <div className={`flex flex-row justify-between items-baseline border-b border-gray-300 ${className}`}>
      <h3 className="basis-3/12 md:basis-2/12 text-xs font-medium text-gray-500 mt-auto">{title}</h3>
      <p className="basis-8/12 md:basis-9/12 break-all mt-auto">{text}</p>
    </div>
  )
}
